import { useTranslation } from "react-i18next";
import { Languages } from "lucide-react";

/**
 * UI language switcher. Independent from the diagnostic locale (driven by
 * `groupe.langue` server-side). A DR with FR UI can still read an EN diagnostic
 * for a UK group.
 */
export default function LanguageSwitcher({ className = "" }) {
  const { i18n } = useTranslation();
  const current = (i18n.language || "fr").startsWith("en") ? "en" : "fr";
  const setLang = (lng) => {
    // Remember the user's explicit choice so we don't auto-overwrite it
    // at next login based on their group country.
    localStorage.setItem("delphi_user_picked_lang", "1");
    i18n.changeLanguage(lng);
  };

  return (
    <div
      className={`inline-flex items-center gap-1 bg-bg-soft border border-border rounded-md p-0.5 ${className}`}
      data-testid="language-switcher"
      role="group"
      aria-label="Language"
    >
      <Languages className="w-3.5 h-3.5 text-text-secondary ml-1.5" aria-hidden />
      <button
        type="button"
        data-testid="lang-fr-btn"
        onClick={() => setLang("fr")}
        className={`px-2 py-0.5 text-xs font-medium rounded transition-colors ${
          current === "fr"
            ? "bg-white text-apollo-orange-dark shadow-sm"
            : "text-text-secondary hover:text-text-primary"
        }`}
        aria-pressed={current === "fr"}
      >
        FR
      </button>
      <button
        type="button"
        data-testid="lang-en-btn"
        onClick={() => setLang("en")}
        className={`px-2 py-0.5 text-xs font-medium rounded transition-colors ${
          current === "en"
            ? "bg-white text-apollo-orange-dark shadow-sm"
            : "text-text-secondary hover:text-text-primary"
        }`}
        aria-pressed={current === "en"}
      >
        EN
      </button>
    </div>
  );
}
